// src/components/Hero.jsx
import { ChevronDown, MessagesSquare, Store } from "lucide-react";
import Particles from "./Particles";
import { useServerStatus } from "../hooks/useServerStatus";


function DiscordIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path d="M19.54 5.34A16.3 16.3 0 0 0 15.47 4c-.2.36-.43.84-.59 1.22a15.2 15.2 0 0 0-4.51 0A12.7 12.7 0 0 0 9.77 4a16.7 16.7 0 0 0-4.08 1.35C3.1 9.18 2.4 12.92 2.75 16.61a16.5 16.5 0 0 0 5 2.53c.4-.55.76-1.13 1.07-1.74a10.6 10.6 0 0 1-1.68-.8l.41-.32a11.7 11.7 0 0 0 10.15 0l.41.32c-.54.31-1.1.58-1.68.8.31.61.67 1.19 1.07 1.74a16.4 16.4 0 0 0 5-2.53c.41-4.28-.7-7.98-2.96-11.27ZM9.2 14.39c-1 0-1.83-.92-1.83-2.05 0-1.13.8-2.06 1.83-2.06 1.02 0 1.84.93 1.82 2.06 0 1.13-.8 2.05-1.82 2.05Zm6.36 0c-1 0-1.83-.92-1.83-2.05 0-1.13.8-2.06 1.83-2.06 1.02 0 1.84.93 1.82 2.06 0 1.13-.8 2.05-1.82 2.05Z" />
    </svg>
  );
}

const heroBg = {
  position: "absolute",
  inset: 0,
  background: [
    "radial-gradient(ellipse 100% 100% at 50% 0%, rgba(10,10,20,0) 0%, rgba(10,10,20,0.5) 50%, rgba(10,10,20,1) 90%)",
    "radial-gradient(ellipse 80% 60% at 50% 30%, rgba(55,15,95,.45) 0%, transparent 65%)",
    `url('${process.env.PUBLIC_URL}/background.png') center 10% / cover no-repeat`,
    "linear-gradient(180deg,#060610 0%,#0d0818 100%)",
  ].join(", "),
};

export default function Hero({
  heroHeight,
  onOpenStore,
  onCopyIP,
  onOpenForum,
}) {
  const { minecraft, loaded } = useServerStatus();
  const mcOnline = loaded ? minecraft.online : null;

  return (
    <div className="toa-hero" style={{ height: heroHeight }}>
      <div style={heroBg} />

      <Particles />

      <div className="toa-hero-content">

        {/* TOA logo */}
        <div
  className="toa-hero-icon"
  style={{
    WebkitMaskImage: `url(${process.env.PUBLIC_URL}/icon.svg)`,
    maskImage: `url(${process.env.PUBLIC_URL}/icon.svg)`,
  }}
/>

        <div className="toa-hero-est">
          Est. 2024
        </div>

        <h1 className="toa-hero-title">
          The Ones Above
        </h1>

        <p className="toa-hero-slogan">
          <em>Rise Above.</em> Grow Together.
        </p>

        <div
          className="toa-hero-ip"
          onClick={onCopyIP}
        >
          <span className="toa-hero-ip-top">
            <div
              className="toa-dot"
              style={{
                background:
                  mcOnline === null
                    ? "#888"
                    : mcOnline
                    ? "#4ade80"
                    : "#ef4444",

                boxShadow:
                  mcOnline
                    ? "0 0 8px #4ade80"
                    : "none",

                flexShrink: 0,
              }}
            />

            <span className="toa-hero-ip-label">
              Minecraft&nbsp;·&nbsp;
              <strong>
                play.theonesabove.com
              </strong>
            </span>
          </span>

          <span className="toa-hero-ip-sep">
            &nbsp;·&nbsp;
          </span>

          <span
            className="toa-hero-ip-status"
            style={{
              color:
                mcOnline === null
                  ? "#888"
                  : mcOnline
                  ? "#4ade80"
                  : "#ef4444",
            }}
          >
            {mcOnline === null
              ? "Checking..."
              : mcOnline
              ? `Online · ${minecraft.playerCount}/${minecraft.maxPlayers}`
              : "Offline"}
          </span>
        </div>

        <div className="toa-hero-ctas">
          <a
            href="https://discord.gg/AzrauJnuqw"
            target="_blank"
            rel="noreferrer"
            className="toa-btn toa-btn-p"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
          >
            <DiscordIcon size={16} />
            Join
          </a>

          <a
            href="/forum"
            className="toa-btn toa-btn-ghost"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              onOpenForum?.();
            }}
          >
            <MessagesSquare style={{ width: 16, height: 16, flexShrink: 0 }} />
            Forums
          </a>

          <button
            className="toa-btn toa-btn-g"
            style={{
              fontSize: 14,
              padding: "13px 28px",
            }}
            onClick={onOpenStore}
          >
            <Store style={{ width: 16, height: 16, flexShrink: 0 }} />
            Store
          </button>
        </div>
      </div>

      {/* Hidden on mobile via CSS class */}
      <div className="toa-hero-scroll">
        <ChevronDown className="toa-ico" />
        <div>Scroll</div>
      </div>
    </div>
  );
}